import { Link } from 'react-router-dom';
import '../Styles/utilsStyle.css';

function HowItWorks() {
    return (
        <div className="mainContainer">
            <h1>How It Works</h1>
            <div className="content">
                <p>
                    BCA is an unconventional auction website where you can’t see other people’s bids; you will only see
                    advancing rounds of a service fee that is paid to advance, with the goal being to get to the best and
                    final stage. Even if you don’t win, you’re still positioned well for the next auction you participate
                    in. Please contact the office nearest to you for more information.
                </p>

                <div className="howItWorks">
                    <div className="workCards">
                        <div className="card">
                            <h2>Future</h2>
                            <p>
                                For each auction you enter, the service fee is required to be paid to advance to the next
                                round. Accumulated service fees from current and previous auctions can be applied as part
                                of the down payment in the best and final stage if you win the auction.
                                <br /><br />
                                <strong>Please note:</strong> accumulated service fees cannot be used for advancing rounds.
                            </p>
                        </div>

                        <div className="card">
                            <h2>Financing</h2>
                            <p>
                                Financing for winners is in place if they choose to take advantage of it for items that
                                apply. This is a very advantageous loan. A minimum of 5% in cash is required, and this
                                can be paired with your accumulated service fees from previous auctions.
                                <br /><br />
                                <strong>Please note:</strong> accumulated service fees can also be applied with the BCA
                                corporate lender to possibly lend on an asset that is not being sold through BCA. Any
                                questions or concerns, please contact the office nearest to you for more information.
                            </p>
                        </div>

                        <div className="card">
                            <h2>Opportunity</h2>
                            <p>
                                The door has been opened to you.
                                <br /><br />
                                Sellers and/or authorized agents can submit items to be auctioned. An initial submission
                                fee is required when BCA has approved and accepted. This fee goes towards building
                                marketing materials to help push the assets to the right buyers and get the desired
                                asking price.
                            </p>
                        </div>
                    </div>
                </div>

                <p>
                    <span className="italic">
                        The presumed value has no relevance to the minimum requirement. The advantage this creates is that
                        if a Bidder overpays for the item based on their evaluation, it is still a win-win scenario.
                    </span>
                </p>
            </div>

            <Link to="/create-auction" style={{ textDecoration: 'none' }}>
                <button className="createItemBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" />
                    </svg>
                    Create Auction
                </button>
            </Link>
        </div>
    );
}

export default HowItWorks;
